/** Utility functions for the namespace feature. */

/** Format epoch seconds to a human-readable date string (DD/MM/YYYY). */
export function formatEpochDate(epochSeconds?: number | null): string {
  if (epochSeconds == null) return '—';
  return new Date(epochSeconds * 1000).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
